import React, { ChangeEvent, Component, FormEventHandler, Fragment, FunctionComponent, useContext, useEffect, useRef, useState } from 'react';
import InputMask from 'react-input-mask';
import './StandardInput.scss';
import IStandardInput from '../interfaces/StandardInput';
import {FormContext} from '../../../context/FormContext';
import KeyReplace from '../../KeyReplace';
import Autocomplete from "react-google-autocomplete";

interface IProps {
  component:IStandardInput;
  parentAlias:string;
  formDirty:boolean;
  validationHandler(alias:string, isValid:boolean):void;
  isDisabled:boolean;
  percentage?:number;
}

const StandardInput:FunctionComponent<IProps> = props => {
  
  const usDateFormat = 'mm/dd/yyyy';
  const caDateFormat = 'dd/mm/yyyy';

  const formContext = useContext(FormContext);

  let [useDefault, setUseDefault] = useState<boolean>(props.component.defaultValue ? true : false);
  const [inputValue, setInputValue] = useState<string>(getValue());
  let [isValid, setIsValid] = useState<boolean>();
  let [isTouched, setIsTouched] = useState<boolean>(false);
  let [hasFocus, setHasFocus] = useState<boolean>(false);
  let [hasError, setHasError] = useState<boolean>(false);
  
  let [tempNumber, setTempNumber] = useState<number>(0.00);

  const inputRef:any = useRef(null);
  
  const autoRef:any = useRef(null);

  function getAlias():string {
    return props.parentAlias + '.' + props.component.alias;
  }

  function setSystemValue(value:string) {
    if(props.component.setSystemValue && formContext.updateFormData) {
      formContext.updateFormData("system." + props.component.setSystemValue , value );
    }
  }

  function onValueChange(e:React.ChangeEvent<HTMLInputElement>|ChangeEvent<HTMLTextAreaElement>) {
    setUseDefault(false);
    //setIsTouched(true);
    let value = e.target.value;
    if(props.component.format && props.component.format === 'number' ) {
      if(value) {
        if(props.component.showCommas === false) {
          value = value.replace(/\D/g,'');
        } else {
          value = Number(value.replace(/\D/g,'')).toLocaleString('en-US');
        }
        
      } 
    }
    if(value) {
      value = value.replace(/"/g, '');
    }

    if(props.component.format && props.component.format === 'currency') {
      
      if(value) {
        
          value = Number(value.replace('.00','').replace(/\D/g,'')).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
          forceCursor();
        
      } 
    }
    if(formContext.updateFormData) {
      formContext.updateFormData(getAlias(), value);
      setInputValue(value);
      
    }
    
  }
  
  function forceCursor() {
     if (inputRef) {
       inputRef.current.selectionStart = inputRef.current.value.length - 3;
       inputRef.current.selectionEnd = inputRef.current.value.length - 3;
     }
  }

  function getDefaultValue():string {
    let defaultValue = props.component.defaultValue;
    if (defaultValue === '{percentage}' && props.percentage) {
      defaultValue = String(props.percentage) || '';
    }
    return defaultValue || '';
  }


  // function getInitialValue():string {
  //   let value = formContext.formData?.get(getAlias());
    
  //   if(value != undefined && !useDefault) {
  //     return value;
  //   } else if (props.component.defaultValue) {
  //     value = getDefaultValue();
  //     if(formContext.updateFormData) {
  //       formContext.updateFormData(getAlias(), value);
        
  //     }
  //     return value
  //   } else {
  //     return '';
  //   }
  // }

  function diff_years(dt2:Date, dt1:Date) 
  {
 
   var diff =(dt2.getTime() - dt1.getTime()) / 1000;
    diff /= (60 * 60 * 24);
   return Math.abs(Math.round(diff/365.25));
    
  }

  function getValue():string {
    let value = formContext.formData?.get(getAlias());
    
    if(value != undefined && !useDefault) {
      return value;
    } else if (props.component.defaultValue) {
      return getDefaultValue();
    } else {
      return '';
    }
  }



  function validate() {
    //if (isTouched) {
     //if(inputValue) {
     //  console.log(inputValue);
     //}
    
    let isFieldValid = true;
    let override = false;
    
    let passesValidationRule = true;


    
    

    if(!override && props.component.required && !props.isDisabled) {
      if(!inputValue || !inputValue.trim()) {
        isFieldValid = false;  
      }
    }

    if(!override && props.component.validationRule) {
      //console.log('called');

      let validationRule = props.component.validationRule.split(' ');
      //console.log(validationRule);
      //console.log(validationRule[1]);
      let checkValue = formContext.formData?.get(validationRule[1]);
      let checkValues:string[] = [];
      

      if (!checkValue) {
        
        if(validationRule[1].includes("*")) {
          
          let index = 0;
          while(true) {
            index = index + 1;
            let checkIndexAlias = validationRule[1].replace('*', String(index));
            
            let indexKey = formContext.formData?.get(checkIndexAlias);
            if(indexKey && checkIndexAlias != getAlias()) {
              checkValues.push(indexKey);
            } else {
              break;
            }
          }
        } else if (validationRule[1].includes(",")) {
          let checkListValues = validationRule[1].split(',')
          checkListValues.forEach((value) => {
            let checkListValue = formContext.formData?.get(value);
            
            if (checkListValue) {
              checkValues.push(checkListValue);
            }
          });
        } else {
          checkValue = validationRule[1];
        }
      }

      if(checkValue && checkValues.length === 0) {
        checkValues = [checkValue];
      } 



      checkValues.forEach((checkValue:string) => {
        if (validationRule[0] === 'length') {
        
          if (Number(checkValue) != inputValue.length) {
            passesValidationRule = false;
          }
        }
        if (validationRule[0] === 'dob') {
           let birthDate = getDateFromStringUS(inputValue)
           let today = new Date();
           var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
           //console.log("age: " + age);
          if (Number(checkValue) > age) {
            passesValidationRule = false;
          }
        }
        if (validationRule[0] === 'eq') {
          if (checkValue != inputValue) {
            passesValidationRule = false;
          }
        }
        if (validationRule[0] === 'gte') {
          if (!checkValue) {
            checkValue = '0';
          }
          
          if (Number(checkValue.replaceAll(',','')) > Number(inputValue.replaceAll(',',''))) {
            passesValidationRule = false;
          }
        }
        if (validationRule[0] === 'neq') {
          if (checkValue === inputValue) {
           
            passesValidationRule = false;
          }
        }
       
      });
      
      if (validationRule[0] === 'sum100') {
        let index = 0;
        let total = 0;
          while(true) {
            index = index + 1;
            let checkIndexAlias = validationRule[1].replace('*', String(index));
            
            let indexKey = formContext.formData?.get(checkIndexAlias);
            if(indexKey != undefined) {
              if (indexKey === "") {
                total = total + 1;
              } else {
                total = total + Number(indexKey);
              }
              
            } else {
              break;
            }
          }


        //console.log(getAlias() + "sees" + total);
        if (total != 100) {
          passesValidationRule = false;
        }
      }

    }

    if (!override) {
       //if its a date and required
       if(props.component.format === 'date') {
        if(props.component.required) {
          isFieldValid = validateDate(inputValue);
        }
      }

      if(props.component.format === 'email') {
        if(props.component.required) {
          isFieldValid = validateEmail(inputValue);
        }
      }

      if(props.component.format === 'ssn') {
        if(props.component.required) {
          if(inputValue.includes("_")) {
            isFieldValid = false;
          }
        }
      }
      
      if(props.component.format === 'ein') {
        if(props.component.required) {
          if(inputValue.includes("_")) {
            isFieldValid = false;
          }
        }
      }

      if(props.component.format === 'zip') {
        if(props.component.required) {
          if(inputValue.includes("_")) {
            isFieldValid = false;
          }
        }
      }

      if(props.component.format === 'phone') {
        if(props.component.required || inputValue) {
          if(inputValue.includes("_")) {
            isFieldValid = false;
          }
        }
      }
    }
    if(props.component.format === 'email') {
      //console.log(getAlias() + " " + inputValue + " " + String(isFieldValid && passesValidationRule));
    }
      setIsValid(isFieldValid && passesValidationRule);
      props.validationHandler(getAlias(), (isFieldValid && passesValidationRule));
    //}
  }

  function overrideChange(event:React.ChangeEvent<HTMLInputElement>) {
    
    if (event.target.checked) {
      cloneFields(true);
    } else {
      cloneFields(false);
    }
    
  }

  React.useEffect(() => {
   setSystemValue(inputValue); 
   validate();
  }, [inputValue])


  React.useEffect(() => {
    if (props.component.defaultValue) {
      if(formContext.updateFormData) {
        formContext.updateFormData(getAlias(), getDefaultValue());
        //setInputValue(value);
        
      }
    }
   }, [])

  // React.useEffect(() => {
    
  //   if (props.percentage && !isTouched) {
      
  //     if(formContext.updateFormData) {
  //       let value = getDefaultValue();
  //       formContext.updateFormData(getAlias(), value);
  //       setInputValue(value);
  //     }
  //   }
  //  }, [props.percentage])

  React.useEffect(() => {
    //console.log(props.component.alias + " " + formContext.formRevision);
    let value = getValue();
    
    if(value !== inputValue) {
      setIsTouched(true);
      setInputValue(value);
      if(formContext.updateFormData) {
        formContext.updateFormData(getAlias(), value);
      }
    }
    validate();
   }, [formContext.formRevision, props.percentage])
 


  function blurHandler() {
    setIsTouched(true);
    validate();
    setHasFocus(false);
  }
  
  function focusHandler() {
    // if (props.component.format && props.component.format === 'currency' && !inputValue) {
    //   setInputValue('0.00');
    // }
    setHasFocus(true);
  }

  React.useEffect(() => {
    if(isTouched && !isValid) {
      setHasError(true);
    } else {
      setHasError(false);
    }
  }, [hasFocus, isTouched, isValid])

  React.useEffect(() => {
    if(props.formDirty) {
      setIsTouched(true);
      validate();
    }
   
   }, [props.formDirty])


  function getDateFromStringUS(date:string) {
    let dateParts = date.split('/');
    let year = Number(dateParts[2]);
        let month = Number(dateParts[0]) - 1;
        let day = Number(dateParts[1]);
        let composedDate = new Date(year, month , day );
        return composedDate;
  }

  function validateDate(date:string) {
    if(date) {
      let dateParts = date.split('/');
      
      if (formContext.formData?.get('system.country') === 'us') {
        let year = Number(dateParts[2]);
        let month = Number(dateParts[0]) - 1;
        let day = Number(dateParts[1]);
        let composedDate = new Date(year, month , day );
        return composedDate.getDate() == day &&
            composedDate.getMonth() == month &&
            composedDate.getFullYear() == year;
      } else {
        let year = Number(dateParts[2]);
        let month = Number(dateParts[1]) - 1;
        let day = Number(dateParts[0]);
        let composedDate = new Date(year, month , day );
        return composedDate.getDate() == day &&
            composedDate.getMonth() == month &&
            composedDate.getFullYear() == year;
      }
    } else {
      return false;
    }

  } 

  function getSsnMask():string {
    

    
    return formContext.formData?.get('system.country') === 'us' ? "999-99-9999" : "999-999-999";
  }

  function getEinMask():string {
    
    return formContext.formData?.get('system.country') === 'us' ? "99-9999999" : "999999999";
  }

  function validateEmail(email:string) 
    {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    function cloneFields(add:boolean) {
      if(props.component.overrideFields && props.component.overrideFields.length > 0) {
        props.component.overrideFields.forEach((override:string) =>
          {
            let overrideFields = override.split("|");
            
            let mainValue = formContext.formData?.get(overrideFields[0]);
            if (formContext.updateFormData) {
              if(add) {
                formContext.updateFormData(overrideFields[1], mainValue || '');
              } else {
                formContext.updateFormData(overrideFields[1], '');
              }
              
            }
            
          }
        )
      }
    }

    function getInputMode():"email" | "text" | "none" | "tel" | "url" | "numeric" | "decimal" | "search" | undefined {
      if (props.component.format === 'email') {
        return "email";
      } else if (props.component.format === 'number') {
        return "numeric";
      } else {
        return undefined;
      }
    }

function onPlaceSelected(place:any) {
  //console.log(place);
  if (place.formatted_address) {
    let splitAddress = place.formatted_address.split(',');
    let splitStateZip = splitAddress[2].trim().split(' ');
    let address1 = splitAddress[0].trim();
    let city = splitAddress[1].trim();
    let state = splitStateZip[0].trim();
    let zip = (splitStateZip[1] || '').trim();
    autoRef.current.value = address1;

    if(formContext.bulkUpdateFormData) {
      let values = [];
      
      if(props.component.addressMap) {
        values.push({key: getAlias(), value: address1});
        values.push({key: props.parentAlias + '.' + props.component.addressMap.city.replace('this.', ''), value: city || ''});
        values.push({key: props.parentAlias + '.' + props.component.addressMap.state.replace('this.', ''), value: state || ''});
        values.push({key: props.parentAlias + '.' + props.component.addressMap.zip.replace('this.', ''), value: zip || ''})
        formContext.bulkUpdateFormData(values);
        setInputValue(address1);
      }
      
        
    }
  }

}

  return (
    <Fragment>
      
    <div className={"standard-input " + (hasError ? 'error' : '') + (props.isDisabled ? ' disabled' : '')}>
       {props.component.canOverride && <label className="override"><input type="checkbox" onChange={overrideChange} /><KeyReplace string={props.component.overrideLabel || ''} /> </label>}
        <label className={(props.component.hideLabel === true ? 'hidden' : '') + (props.component.showDollar ? 'dollar' : '')} htmlFor={getAlias()}><KeyReplace string={props.component.label} />{props.component.required && <span className="required">*</span>}</label>
        {(!props.component.format || props.component.format === "number" || props.component.format === "email") &&
          <input disabled={props.isDisabled} maxLength={(props.component.maxChars || 64)} inputMode={getInputMode()}  pattern={props.component.format === 'number' ? "[0-9.,]+" : ''} onBlur={blurHandler} onFocus={focusHandler} name={getAlias()} id={getAlias()}  onChange={onValueChange} value={inputValue} readOnly={props.component.readOnly || false} />
        }
        {props.component.format === "percent" && 
          <input disabled={props.isDisabled} maxLength={(props.percentage === 100 ? 3 : 2)} inputMode={getInputMode()}  pattern={"[0-9]+"} onBlur={blurHandler} onFocus={focusHandler} name={getAlias()} id={getAlias()}  onChange={onValueChange} value={inputValue} />
        }
        {props.component.format === "date" && 
          <InputMask mask="99/99/9999" inputMode={"numeric"} pattern="[0-9]*" spellCheck={"false"}  maskPlaceholder={formContext.formData?.get('system.country') === 'us' ? usDateFormat : caDateFormat} onBlur={blurHandler} onFocus={focusHandler} name={getAlias()} id={getAlias()}  onChange={onValueChange} value={inputValue} />
        }
        {props.component.format === "zip" && 
          <InputMask mask={formContext.formData?.get('system.country') === 'us' ? "99999" : "*** ***"} inputMode={formContext.formData?.get('system.country') === 'us' ? "numeric" : undefined} pattern={formContext.formData?.get('system.country') === 'us' ? "[0-9]*" : ""} spellCheck={"false"} onBlur={blurHandler} onFocus={focusHandler} name={getAlias()} id={getAlias()}  onChange={onValueChange} value={inputValue} />
        }
        {props.component.format === "phone" && 
          <InputMask mask="+1 (999) 999-9999" inputMode={"numeric"} pattern="[0-9]*" onBlur={blurHandler} onFocus={focusHandler} name={getAlias()} id={getAlias()}  onChange={onValueChange} value={inputValue} />
        }
        {props.component.format === "simplephone" && 
          <InputMask mask="999 999-9999" inputMode={"numeric"} pattern="[0-9]*" onBlur={blurHandler} onFocus={focusHandler} name={getAlias()} id={getAlias()}  onChange={onValueChange} value={inputValue} />
        }
        {props.component.format === "ssn" && 
          <InputMask mask={getSsnMask()} inputMode={"numeric"} pattern="[0-9]*" onBlur={blurHandler} onFocus={focusHandler} name={getAlias()} id={getAlias()}  onChange={onValueChange} value={inputValue} />
        }
        {props.component.format === "ein" && 
          <InputMask mask={getEinMask()} inputMode={"numeric"} pattern="[0-9]*" onBlur={blurHandler} onFocus={focusHandler} name={getAlias()} id={getAlias()}  onChange={onValueChange} value={inputValue} />
        }
        {props.component.format === "currency" && 
          <input ref={inputRef} onClick={forceCursor} onKeyDown={forceCursor} onKeyPress={forceCursor} onKeyUp={forceCursor} inputMode={"numeric"} onBlur={blurHandler} onFocus={focusHandler} name={getAlias()} id={getAlias()}  onChange={onValueChange} value={inputValue} />
        }
        {props.component.format === "textarea" && 
          <Fragment>
          <div className="char-count">{getValue().length + "/" + props.component.maxChars}</div>
          <textarea placeholder={props.component.placeHolder} onBlur={blurHandler} maxLength={props.component.maxChars} onFocus={focusHandler} name={getAlias()} id={getAlias()}  onChange={onValueChange} value={inputValue} />
          </Fragment>
        }
        {props.component.format === "address" && 
          <Autocomplete placeholder='' onBlur={blurHandler} onFocus={focusHandler} id={getAlias()} defaultValue={inputValue}  onChange={(e:ChangeEvent<HTMLInputElement>) => onValueChange(e)} ref={autoRef} apiKey={'AIzaSyCOrCp0M_xtmnsBieW7bK3iaB2RLQoUpKI'} inputAutocompleteValue={'new-password'} options={{
    types: ["address"],
    componentRestrictions: { country: "us" },
  }} onPlaceSelected={(place) => onPlaceSelected(place)} />}
        {hasError && props.component.errorMessage && <strong><KeyReplace string={props.component.errorMessage || ''} /></strong>}
        {props.component.hint && <span className="hint"><KeyReplace string={props.component.hint} /></span>}
    </div>
    </Fragment>
  );
}

export default StandardInput;